<script setup lang="ts">
import circle from "@/assets/img/loading-circle.png"
import unicorn from "@/assets/img/loading-unicorn.png"

const props = withDefaults(
  defineProps<{
    isDefault?: boolean
    size?: string
  }>(),
  {
    isDefault: true,
    size: "h-32 w-32",
  }
)
</script>

<template>
  <div class="flex items-center justify-center">
    <!-- Loading animated circle with unicorn inside -->
    <template v-if="props.isDefault">
      <div :class="`${props.size} animate-spin`">
        <img
          :src="circle"
          alt=""
          class="absolute top-1/2 left-1/2 h-32 w-32 -translate-x-1/2 -translate-y-1/2"
          :class="props.size"
        />
      </div>
      <img
        :src="unicorn"
        alt=""
        class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
        :class="props.size"
      />
    </template>

    <!-- Branding color loader -->
    <div v-else :class="props.size">
      <span
        class="inline-block h-full w-full animate-spin rounded-full bg-[conic-gradient(from_0deg,var(--af-gradient-start)_0deg,var(--af-gradient-start)_140deg,var(--af-gradient-end)_220deg,var(--af-gradient-end)_360deg)] p-1.5 [animation-duration:1.5s]"
      >
        <span class="block h-full w-full rounded-full bg-white"></span>
      </span>
    </div>
  </div>
</template>
